import { Panel } from "./common";
import { BESOINS, fmtEUR, slug } from "../lib/constants";

const rate = (s, p) => (s + p ? Math.round((s / (s + p)) * 100) : null);
const pct = (v) => (v === null ? "—" : `${v} %`);

const Row = ({ id, label, signees, perdues, taux, ca, total = false }) => (
  <tr data-testid={`conversion-row-${id}`} className={total ? "font-semibold text-[var(--kc-navy)]" : "text-[var(--kc-ink)]"}>
    <td className="py-3 pr-4">{label}</td>
    <td className="py-3 pr-4 text-right font-mono" data-testid={`conversion-signees-${id}`}>{signees}</td>
    <td className="py-3 pr-4 text-right font-mono text-[var(--kc-muted)]">{perdues}</td>
    <td className="py-3 pr-4">
      <div className="flex items-center gap-3">
        <div className="h-2 flex-1 overflow-hidden rounded-full bg-[var(--kc-sand)]">
          <div className="h-full rounded-full bg-[#0F8A5F] transition-[width] duration-700" style={{ width: `${taux || 0}%` }} />
        </div>
        <span className="w-12 text-right font-mono text-sm" data-testid={`conversion-taux-${id}`}>{pct(taux)}</span>
      </div>
    </td>
    <td className="py-3 text-right font-mono" data-testid={`conversion-ca-${id}`}>{fmtEUR(ca)}</td>
  </tr>
);

export const ConversionPanel = ({ demandes, missions }) => {
  const rows = BESOINS.map((b) => {
    const signees = demandes.filter((d) => d.etape === "mission_signee" && d.besoins.includes(b)).length;
    const perdues = demandes.filter((d) => d.etape === "perdu" && d.besoins.includes(b)).length;
    const ca = missions.filter((m) => m.type === b).reduce((s, m) => s + (m.montant || 0), 0);
    return { id: slug(b), label: b, signees, perdues, taux: rate(signees, perdues), ca };
  });
  const sig = demandes.filter((d) => d.etape === "mission_signee").length;
  const perd = demandes.filter((d) => d.etape === "perdu").length;
  const caTotal = missions.reduce((s, m) => s + (m.montant || 0), 0);

  return (
    <Panel testId="dashboard-conversion-panel" title="Taux de signature & CA signé par type de besoin">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="kc-eyebrow border-b border-[var(--kc-line)] text-left">
              <th className="pb-3 pr-4 font-semibold">Besoin</th>
              <th className="pb-3 pr-4 text-right font-semibold">Signées</th>
              <th className="pb-3 pr-4 text-right font-semibold">Perdues</th>
              <th className="pb-3 pr-4 font-semibold">Taux de signature</th>
              <th className="pb-3 text-right font-semibold">CA signé HT</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-[var(--kc-line)]">
            {rows.map((r) => <Row key={r.id} {...r} />)}
            <Row id="total" label="Ensemble du cabinet" signees={sig} perdues={perd} taux={rate(sig, perd)} ca={caTotal} total />
          </tbody>
        </table>
      </div>
      <p className="mt-4 text-xs text-[var(--kc-muted)]">Taux = demandes signées ÷ (signées + perdues). CA signé = montant HT des missions par type.</p>
    </Panel>
  );
};
